import { Stack } from '@unifyapps/ui/components/Stack';
import { useMemo, useState } from 'react';
import { useParams, usePathname } from '../../../../../navigation';
import type { Navigation } from '../../../types';
import { getActivePathnames } from '../../../utils';
import { ItemRenderer } from './ItemRenderer';

export function DrawerBody({ navigation }: { navigation: Navigation }) {
  const [openGroupId, setOpenGroupId] = useState<string | null>(null);

  const { primary, secondary } = navigation;
  const pathname = usePathname();
  const { projectSlug } = useParams<{ projectSlug?: string }>();

  const activePathnames = useMemo(
    () => getActivePathnames(pathname, projectSlug),
    [pathname, projectSlug],
  );

  return (
    <Stack className="w-full flex-1" direction="column" justifyContent="space-between">
      <Stack className="gap-xs px-xl w-full" direction="column">
        {primary.map((navItem) => {
          return (
            <ItemRenderer
              activePathnames={activePathnames}
              key={navItem.id}
              navItem={navItem}
              openGroupId={openGroupId}
              setOpenGroupId={setOpenGroupId}
            />
          );
        })}
      </Stack>
      <Stack className="gap-xs pb-lg w-full" direction="column">
        {secondary?.map((navItem) => {
          return (
            <ItemRenderer
              activePathnames={activePathnames}
              className="mx-xl"
              key={navItem.id}
              navItem={navItem}
            />
          );
        })}
      </Stack>
    </Stack>
  );
}
